export const defaultValue: string = 'DEFAULT'

export enum AnswerType {
  text = 'String',
  conditional = 'Boolean',
  numeric = 'Int32',
}

export enum QuestionCode {
  MULTI_COMPANY = 'IsMultiCompany',
  OMNI_DECIMAL_ROUNDING = 'OmniDecimalRounding',
  SEASONS_NOT_TO_IMPORT_PIM = 'SeasonsNotToImportPIM',
}

export enum SettingsName {
  Application = 'Application',
  DescriptionsAndSEO = 'DescriptionsAndSeoSettings',
  Gallery = 'Gallery',
  Channel = 'Channel',
  Site = 'Site',
  Season = 'Season',
  Store = 'Store',
  User = 'User',
}

export interface TreeSelectOption {
  label: string
  value: string
  key: string
  priority: number
  checkable: boolean
  className: string
}

export const SettingsApplicationSelectAll: string = 'all'
export const SettingsAnswerEmptyValue: string = 'empty'
export const SettingsChangePriorityValue: string = 'priority'
export const SettingsQuestionNameMandatory: string = 'Obbligatorio'
export const SettingsQuestionNameVisibility: string = 'Visibilità'
export const ChannelSettingsReset: string = 'Reset'

export const SettingsDependencies: Record<SettingsName, SettingsName[]> = {
  [SettingsName.Application]: [SettingsName.Application],
  [SettingsName.DescriptionsAndSEO]: [SettingsName.DescriptionsAndSEO, SettingsName.Channel],
  [SettingsName.Gallery]: [SettingsName.Gallery, SettingsName.Channel, SettingsName.Site],
  [SettingsName.Channel]: [SettingsName.Channel, SettingsName.DescriptionsAndSEO, SettingsName.Gallery],
  [SettingsName.Site]: [SettingsName.Site, SettingsName.Gallery],
  [SettingsName.Season]: [SettingsName.Season],
  [SettingsName.Store]: [SettingsName.Store],
  [SettingsName.User]: [SettingsName.User],
}

export const BaseSettings: SettingsName[] = [SettingsName.Season]

export const OnlyPIMSettings: SettingsName[] = [
  SettingsName.Application,
  SettingsName.DescriptionsAndSEO,
  SettingsName.Gallery,
  SettingsName.Channel,
  SettingsName.Site,
  SettingsName.Season,
]

export const OnlyOmniSettings: SettingsName[] = [SettingsName.Application, SettingsName.Season]
